<template>
  <div class="containerGeralMdfe">
    <div class="title">
      <b-icon-file-earmark-medical></b-icon-file-earmark-medical>
      <span> Manifesto Eletrônico </span>
    </div>
    <div class="rowContainer">
      <span>
        <b-icon-person-lines-fill></b-icon-person-lines-fill> Dados Gerais</span
      >
      <div class="rowContent" style="justify-content: flex-start !important">
        <div class="selectPlus" style="width: 25% !important">
          <label class="fixedSelect2">Ambiente</label>
          <b-form-select
            :class="`borderInput shadow-none ${isInvalidInput}`"
            value-field="value"
            text-field="text"
            v-model="dadosMdfe.ambiente"
            :options="ambiente"
            @blur.native="clearInvalidInput"
          >
          </b-form-select>
        </div>
        <div class="selectPlus" style="width: 25% !important">
          <label class="fixedSelect2">Emitente</label>
          <b-form-select
            :class="`borderInput shadow-none ${isInvalidInput}`"
            value-field="value"
            text-field="text"
            v-model="dadosMdfe.emitente"
            :options="emitente"
            @blur.native="clearInvalidInput"
            ref="emitente"
          >
          </b-form-select>
        </div>
        <!-- <div class="selectPlus" style="width: 25% !important">
          <label class="fixedSelect2">Tipo Transportador</label>
          <b-form-select
            :class="`borderInput shadow-none ${isInvalidInput}`"
            value-field="value"
            text-field="text"
            v-model="dadosMdfe.transportador"
            :options="transportador"
            @blur.native="clearInvalidInput"
            ref="transportador"
          >
          </b-form-select>
        </div> -->
        <div class="input-group-key">
          <input
            v-model="chaves"
            ref="chaves"
            :class="`input borderInput ${isInvalidInput}`"
            @blur="clearInvalidInput"
          />
          <label class="user-label-disabledKey"> Chave de Referência </label>
          <button class="addKey" @click="insertKey">Adicionar</button>
        </div>
      </div>
      <div class="rowContent">
        <div class="input-group">
          <b-form-input
            class="input borderInput"
            :value="maskToKg(dadosMdfe.peso_bruto)"
            @input="handleGrossWeight($event)"
          />
          <label class="user-label"> Peso Bruto </label>
        </div>

        <div class="selectPlus">
          <label class="fixedSelect2">Unidade</label>
          <b-form-select
            :class="`borderInput shadow-none ${isInvalidInput}`"
            value-field="value"
            text-field="text"
            v-model="dadosMdfe.unidade"
            :options="unidade"
            @blur.native="clearInvalidInput"
            ref="unidade"
          >
          </b-form-select>
        </div>

        <InputMoney
          label="Valor Total da Carga"
          type="text"
          :dataInput.sync="dadosMdfe.valor_carga"
          ref="valor"
        />
        <div class="contentKey">
          <div class="contentPercurso">
            <ul class="uf-list">
              <li
                v-for="(item, index) in descarregamento.documentos_fiscais"
                :key="index"
              >
                {{ item.chave }}
                <b-icon-x-circle
                  @click="removeKey(index)"
                  class="iconPercurso"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <p class="descriptionObs">Informações complementares</p>
        <textarea
          class="inputTextArea"
          rows="1"
          max-rows="3"
          v-model="dadosMdfe.informacoes_complementares"
        />
      </div>
    </div>
    <div class="rowContainer">
      <span> <b-icon-truck></b-icon-truck> Origem / Destino</span>
      <div class="rowContent">
        <div class="input-group">
          <input
            v-model="cep_carregamento"
            required
            class="input borderInput"
          />
          <label class="user-label"> CEP Origem </label>
          <button class="bcsCep" @click="fetchCepLoading(cep_carregamento)">
            <b-spinner
              v-if="spinGeneral"
              small
              label="Small Spinner"
            ></b-spinner>
            buscar
          </button>
        </div>
        <div class="input-group">
          <input
            v-model="exibitionOrigin"
            disabled
            :class="`input borderInput ${isInvalidInput}`"
            @blur="clearInvalidInput"
          />
          <label class="user-label-disabled"> Origem </label>
        </div>
        <span>/</span>
        <div class="input-group">
          <input
            required
            v-model="cep_descarregamento"
            class="input borderInput"
          />
          <label class="user-label"> CEP Destino </label>
          <button
            class="bcsCep"
            @click="fetchCepUnloading(cep_descarregamento)"
          >
            <b-spinner
              v-if="spinGeneral"
              small
              label="Small Spinner"
            ></b-spinner>
            buscar
          </button>
        </div>
        <div class="input-group">
          <input
            v-model="exibitionDestiny"
            disabled
            :class="`input borderInput ${isInvalidInput}`"
            @blur="clearInvalidInput"
          />
          <label class="user-label-disabled"> Destino </label>
        </div>
      </div>
    </div>
    <div class="rowContainer">
      <span> <b-icon-truck></b-icon-truck> Produto Predominante</span>
      <div class="rowContent">
        <div class="selectPlus" style="width: 25% !important">
          <label class="fixedSelect2">Tipo Da Carga</label>
          <b-form-select
            :class="`borderInput shadow-none ${isInvalidInput}`"
            value-field="value"
            text-field="text"
            v-model="dadosMdfe.produto_predominante.tipo_carga"
            :options="tipoCarga"
            @blur.native="clearInvalidInput"
            ref="tipoCarga"
          >
          </b-form-select>
        </div>
        <InputInfinit
          label="Itens"
          typeFilter="itens"
          :isEdit="dadosMdfe.produto_predominante.idProduto"
          :dataInput.sync="dadosMdfe.produto_predominante.idProduto"
          :onSearch="fillProductsComboBoxWithPaginate"
          :openCreateModal="
            () =>
              handleModalCreateProduct('modalCreateProduct', selectedProduct)
          "
          :findAll="createdNewProducts"
          :clearSelected="toggleClearSelect"
          @selectItem="selectProductSetDefaultValue($event, true)"
        />
        <div class="input-group">
          <input
            v-model="dadosMdfe.produto_predominante.ncm"
            class="input borderInput"
            placeholder="Informar 8 caracteres"
          />
          <label class="user-label"> NCM </label>
        </div>
      </div>
    </div>
    <div class="carroselCtn">
      <div class="StatementOnAccount">
        <label
          v-for="item in tabs"
          :key="item.text"
          class="StatementOnAccountItem"
          :class="{ active: selectedLabel === item.value }"
          @click="storeLabelName(item.text)"
        >
          {{ item.text }} <br />
        </label>
      </div>
    </div>
    <div
      v-show="selectedLabel === 'Dados do Transporte'"
      class="contentOtherInfos"
    >
      <b-card>
        <div class="rowContent" style="align-items: center">
          <div class="input-group">
            <input
              v-model="dadosMdfe.rodoviario.rntrc"
              class="input borderInput"
              placeholder="Informar 8 caracteres"
            />
            <label class="user-label"> RNTRC </label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">Combinação Veicular</label>
            <b-form-select
              class="borderInput shadow-none"
              value-field="value"
              text-field="text"
              :options="combinacao"
              v-model="dadosMdfe.rodoviario.combinacao_veicular"
              ref="combinacao_veicular"
            >
            </b-form-select>
          </div>
          <InputSelect
            label="Motorista"
            :items="conductor"
            ref="refMotorista"
            valueField="id"
            textField="nome"
            :dataSelect.sync="dadosMdfe.idCondutor"
            :openCreateModal="() => openModals('modalConductor')"
          />
          <InputSelect
            label="Veiculos"
            :items="vehicle"
            ref="refVeiculos"
            valueField="id"
            textField="placa"
            :dataSelect.sync="dadosMdfe.rodoviario.idVeiculo"
            :openCreateModal="() => openModals('modalVehicle')"
          />
          <div class="selectPlus">
            <label class="fixedSelect2">UF Percurso</label>
            <b-form-select
              class="borderInput shadow-none"
              value-field="value"
              text-field="text"
              :options="ufs"
              v-model="uniqueRoute"
              ref="uf"
            >
            </b-form-select>
          </div>
          <button class="addRoute" @click="insertRoute">Adicionar</button>
        </div>
        <div class="contentRoute">
          <div class="contentPercurso">
            <ul class="uf-list">
              <li v-for="(item, index) in dadosMdfe.percurso" :key="index">
                {{ item }}
                <b-icon-x-circle
                  @click="removeItem(index)"
                  class="iconPercurso"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="rowContainer" style="width: 70%">
          <span> <b-icon-truck></b-icon-truck> Vale Pedágio </span>
          <div class="rowContent">
            <div class="input-group">
              <input
                v-model="valePedagioAtual.cnpj_fornecedor"
                v-mask="maskCpfCnpjForCnpj"
                maxlength="18"
                @input="checkInputLengthForCnpj"
                class="input borderInput"
              />
              <label class="user-label"> CNPJ do Fornecedor </label>
            </div>
            <div class="input-group">
              <input
                v-mask="maskCpfCnpjresponsavel"
                maxlength="18"
                @input="checkInputLengthresponsavel"
                v-model="valePedagioAtual.cpf_responsavel"
                class="input borderInput"
              />
              <label class="user-label"> CPF do Responsável </label>
            </div>
            <div class="input-group">
              <input
                v-model="valePedagioAtual.comprovante"
                class="input borderInput"
              />
              <label class="user-label"> Comprovante </label>
            </div>

            <InputMoney
              label="Valor"
              type="text"
              :dataInput.sync="valePedagioAtual.valor"
              ref="valorPedagio"
            />
            <button class="btnAdd" @click="adicionarValePedagio">
              Adicionar
            </button>
          </div>
          <div
            class="ContentTable"
            style="margin-top: 0px !important"
            v-if="dadosMdfe.vale_pedagio.length"
          >
            <table>
              <thead class="headTable">
                <tr>
                  <th>N° Comprovante</th>
                  <th>Valor</th>
                  <th></th>
                </tr>
              </thead>
              <tbody
                v-if="dadosMdfe.vale_pedagio.length > 0"
                style="color: #3a4750"
              >
                <tr
                  style="text-align: center; height: 30px; cursor: context-menu"
                  v-for="(item, index) in dadosMdfe.vale_pedagio"
                  :key="index"
                >
                  <td>N°{{ item.comprovante }}</td>
                  <td>
                    {{
                      item.valor.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td>
                    <b-icon-x-circle
                      @click="removerValePedagio(index)"
                      class="tdPercurso"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="rowContainer">
          <span> <b-icon-truck></b-icon-truck> CIOT </span>
          <div class="rowContent" style="align-items: flex-start">
            <div class="input-group">
              <input
                v-model="ciotAtual.cpf_responsavel"
                v-mask="maskCpfCnpjciot"
                maxlength="18"
                @input="checkInputLengthciot"
                class="input borderInput"
              />
              <label class="user-label"> CPF Responsável </label>
            </div>
            <div class="input-group">
              <input
                v-model="ciotAtual.codigo_ciot"
                class="input borderInput"
                placeholder="Informar 12 caracteres"
              />
              <label class="user-label"> CIOT </label>
            </div>
            <button class="btnAdd" @click="adicionarCiot">Adicionar</button>
            <div
              class="ContentTable"
              style="width: 35%; margin-top: 0px !important"
              v-if="dadosMdfe.ciot.length"
            >
              <table>
                <thead class="headTable">
                  <tr>
                    <th>CPF / CNPJ</th>
                    <th>CIOT</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-if="dadosMdfe.ciot.length > 0" style="color: #3a4750">
                  <tr
                    style="
                      text-align: center;
                      height: 30px;
                      cursor: context-menu;
                    "
                    v-for="(item, index) in dadosMdfe.ciot"
                    :key="index"
                  >
                    <td>{{ item.cpf_responsavel }}</td>
                    <td>{{ item.codigo_ciot }}</td>
                    <td>
                      <b-icon-x-circle
                        @click="removerCiot(index)"
                        class="tdPercurso"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              style="
                width: 25%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #e4e4e4;
                padding: 10px;
                border-radius: 8px;
              "
              v-else
            >
              <span>Nenhum CIOT adicionado</span>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div
      v-show="selectedLabel === 'Informações Pagamento'"
      class="contentOtherInfos"
    >
      <b-card>
        <div class="rowContent">
          <div class="input-group">
            <input
              v-model="pagamentoFrete.cpf"
              v-mask="maskCpfCnpjfrete"
              maxlength="18"
              @input="checkInputLengthfrete"
              class="input borderInput"
            />
            <label class="user-label"> CPF do Responsável </label>
          </div>
          <div class="input-group">
            <input v-model="pagamentoFrete.nome" class="input borderInput" />
            <label class="user-label"> Nome do Responsável </label>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">Tipo de Informação Bancária</label>
            <b-form-select
              class="borderInput shadow-none"
              value-field="value"
              text-field="text"
              :options="pagamento"
              v-model="pagamentoFrete.forma_pagamento"
              ref="forma_pagamento"
            >
            </b-form-select>
          </div>
          <InputMoney
            label="Valor do Contrato"
            type="text"
            :dataInput.sync="pagamentoFrete.valor_contrato"
            ref="valorContrato"
          />
          <InputMoney
            label="Valor do Adiantamento"
            type="text"
            :dataInput.sync="pagamentoFrete.valor_adiantamento"
            ref="valorAdiantamento"
          />
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Informações
            Bancárias</span
          >
          <div class="rowContent" style="justify-content: flex-start">
            <div class="selectPlus">
              <label class="fixedSelect2">Tipo de Informação Bancária</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="tipo_informacao_bancaria"
                v-model="
                  pagamentoFrete.informacoes_bancarias.tipo_informacao_bancaria
                "
                ref="tipo_informacao_bancaria"
              >
              </b-form-select>
            </div>
            <div
              class="input-group"
              v-if="
                pagamentoFrete.informacoes_bancarias
                  .tipo_informacao_bancaria === '1'
              "
            >
              <input
                v-model="pagamentoFrete.informacoes_bancarias.numero_banco"
                class="input borderInput"
              />
              <label class="user-label"> N° Banco </label>
            </div>
            <div
              class="input-group"
              v-if="
                pagamentoFrete.informacoes_bancarias
                  .tipo_informacao_bancaria === '1'
              "
            >
              <input
                v-model="pagamentoFrete.informacoes_bancarias.numero_agencia"
                class="input borderInput"
              />
              <label class="user-label"> N° Agência </label>
            </div>
            <div
              class="input-group"
              v-if="
                pagamentoFrete.informacoes_bancarias
                  .tipo_informacao_bancaria === '3'
              "
            >
              <input
                v-model="pagamentoFrete.informacoes_bancarias.pix"
                class="input borderInput"
              />
              <label class="user-label"> PIX </label>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Componentes do
            Pagamento
          </span>
          <div class="rowContent">
            <div class="selectPlus">
              <label class="fixedSelect2">Tipo de Informação Bancária</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="tipocomponente"
                v-model="componenteAtual.tipo_componente"
              >
              </b-form-select>
            </div>
            <InputMoney
              label="Valor do Componente"
              type="text"
              :dataInput.sync="componenteAtual.valor_componente"
              ref="valorComponente"
            />
            <div class="input-group">
              <input
                v-model="componenteAtual.descricao_componente"
                class="input borderInput"
              />
              <label class="user-label"> Descrição </label>
            </div>
            <button class="btnAdd" @click="adicionarComponente">
              Adicionar
            </button>
          </div>
          <div
            class="ContentTable"
            style="margin-top: 0px !important"
            v-if="pagamentoFrete.componentes_pagamento_frete.length"
          >
            <table>
              <thead class="headTable">
                <tr>
                  <th>Tipo</th>
                  <th>Valor</th>
                  <th>Descrição</th>
                  <th></th>
                </tr>
              </thead>
              <tbody
                v-if="pagamentoFrete.componentes_pagamento_frete.length > 0"
                style="color: #3a4750"
              >
                <tr
                  style="text-align: center; height: 30px; cursor: context-menu"
                  v-for="(
                    item, index
                  ) in pagamentoFrete.componentes_pagamento_frete"
                  :key="index"
                >
                  <td v-if="item.tipo_componente === '01'">Vale Pedágio</td>
                  <td v-if="item.tipo_componente === '02'">
                    Impostos, taxas e contribuições
                  </td>
                  <td v-if="item.tipo_componente === '03'">
                    Despesas (bancárias, meios de pagamento, outras)
                  </td>
                  <td v-if="item.tipo_componente === '04'">Frete</td>
                  <td v-if="item.tipo_componente === '99'">Outros</td>
                  <td>
                    {{
                      item.valor_componente.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td>{{ item.descricao_componente }}</td>
                  <td>
                    <b-icon-x-circle
                      @click="removerComponente(index)"
                      class="tdPercurso"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Informações de
            Pagamento a Prazo
          </span>
          <div class="rowContent" style="align-items: flex-start">
            <Input
              ref="data_vencimento_parcela"
              label="Data"
              type="date"
              :dataInput.sync="parcelaAtual.data_vencimento_parcela"
              :labelFixed="true"
            />
            <InputMoney
              label="Valor da Parcela"
              type="text"
              :dataInput.sync="parcelaAtual.valor_parcela"
              ref="valor_parcela"
            />
            <button class="btnAdd" @click="adicionarParcela">Adicionar</button>
            <div
              class="ContentTable"
              style="width: 35%; margin-top: 0px !important"
              v-if="pagamentoFrete.informacoes_pagamento_prazo.length"
            >
              <table>
                <thead class="headTable">
                  <tr>
                    <th>Data Vencimento</th>
                    <th>Valor</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody
                  v-if="pagamentoFrete.informacoes_pagamento_prazo.length > 0"
                  style="color: #3a4750"
                >
                  <tr
                    style="
                      text-align: center;
                      height: 30px;
                      cursor: context-menu;
                    "
                    v-for="(
                      item, index
                    ) in pagamentoFrete.informacoes_pagamento_prazo"
                    :key="index"
                  >
                    <td>
                      {{
                        item.data_vencimento_parcela
                          .split("-")
                          .reverse()
                          .join("/")
                      }}
                    </td>
                    <td>
                      {{
                        item.valor_parcela.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                      }}
                    </td>
                    <td>
                      <b-icon-x-circle
                        @click="removerParcela(index)"
                        class="tdPercurso"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              style="
                width: 25%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #e4e4e4;
                padding: 10px;
                border-radius: 8px;
              "
              v-else
            >
              <span></span>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div v-show="selectedLabel === 'Outros'" class="contentOtherInfos">
      <b-card style="padding: 1rem 0 !important">
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Veículo
            Reboque
          </span>
          <div class="rowContent" style="align-items: center">
            <div class="input-group">
              <input
                v-model="veiculoReboque.placa"
                class="input borderInput"
                placeholder="Informar 7 caracteres"
              />
              <label class="user-label"> Placa </label>
            </div>
            <div class="input-group">
              <input
                v-model="veiculoReboque.renavam"
                class="input borderInput"
                placeholder="Informar 11 caracteres"
              />
              <label class="user-label"> RENAVAM </label>
            </div>
            <div class="input-group" style="width: 15%">
              <input
                v-model="veiculoReboque.tara"
                class="input borderInput"
                placeholder="Informar 7 caracteres"
              />
              <label class="user-label"> Tara (KG) </label>
            </div>
            <div class="input-group" style="width: 15%">
              <input
                v-model="veiculoReboque.capacidade_kg"
                class="input borderInput"
                placeholder="Informar 7 caracteres"
              />
              <label class="user-label"> Capacidade (KG) </label>
            </div>
            <div class="selectPlus">
              <label class="fixedSelect2">Tipo de Carroceria</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="carrocerias"
                v-model="veiculoReboque.tipo_carroceria"
                ref="tipo_carroceria"
              >
              </b-form-select>
            </div>
            <div class="selectPlus">
              <label class="fixedSelect2">UF Licenciamento</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="ufs"
                v-model="veiculoReboque.uf_licenciamento"
                ref="uf_licenciamento"
              >
              </b-form-select>
            </div>
          </div>
          <div class="rowContent" style="align-items: center">
            <div class="input-group" style="width: 15%">
              <input
                v-model="veiculoReboque.proprietario.rntrc"
                class="input borderInput"
                placeholder="Informar 8 caracteres"
              />
              <label class="user-label"> RNTRC </label>
            </div>
            <div class="selectPlus">
              <label class="fixedSelect2">Proprietário</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="tipoDocumento"
                v-model="selectDocument"
              >
              </b-form-select>
            </div>
            <div class="input-group" v-if="selectDocument === 1">
              <input
                v-model="veiculoReboque.proprietario.nome"
                class="input borderInput"
              />
              <label class="user-label" style="left: -3px">
                Nome do proprietário
              </label>
            </div>
            <div class="input-group" v-if="selectDocument === 2">
              <input
                v-model="veiculoReboque.proprietario.razao_social"
                class="input borderInput"
              />
              <label class="user-label" style="left: -3px">
                Razão Social
              </label>
            </div>
            <div
              class="input-group"
              v-if="selectDocument === 2"
              style="width: 20%"
            >
              <input
                v-model="veiculoReboque.proprietario.cnpj"
                v-mask="maskCpfCnpjReboque"
                maxlength="18"
                @input="checkInputLengthReboque"
                class="input borderInput"
              />
              <label class="user-label"> CNPJ </label>
            </div>
            <div class="input-group" v-if="selectDocument === 1">
              <input
                v-mask="maskCpfCnpjReboque"
                maxlength="18"
                @input="checkInputLengthReboque"
                v-model="veiculoReboque.proprietario.cpf"
                class="input borderInput"
              />
              <label class="user-label"> CPF do proprietário </label>
            </div>
            <div
              class="input-group"
              v-if="selectDocument === 2"
              style="width: 15%"
            >
              <input
                v-model="veiculoReboque.proprietario.ie"
                class="input borderInput"
              />
              <label class="user-label"> IE </label>
            </div>
            <div class="selectPlus" style="width: 10%">
              <label class="fixedSelect2">UF </label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="ufs"
                v-model="veiculoReboque.proprietario.uf"
              >
              </b-form-select>
            </div>
            <div class="selectPlus" style="width: 20%">
              <label class="fixedSelect2">Tipo </label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="tipo_proprietario"
                v-model="veiculoReboque.proprietario.tipo_proprietario"
                ref="tipo_proprietario"
              >
              </b-form-select>
            </div>
            <button class="addRoute" @click="insertRebock">Adicionar</button>
          </div>
          <div class="contentReboq">
            <div class="contentPercurso">
              <ul class="uf-list">
                <li
                  v-for="(item, index) in dadosMdfe.rodoviario.veiculo_reboque"
                  :key="index"
                >
                  Nome:
                  {{ item.proprietario.nome || item.proprietario.razao_social }}
                  | Placa: {{ item.placa }} | CPF/CNPJ:
                  {{ item.proprietario.cpf || item.proprietario.cnpj }}
                  <b-icon-x-circle
                    @click="removeRebock(index)"
                    class="iconPercurso"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="rowContainer">
          <span>
            <b-icon-person-lines-fill></b-icon-person-lines-fill> Contratantes
          </span>
          <div class="rowContent" style="justify-content: flex-start">
            <div class="selectPlus">
              <label class="fixedSelect2">Proprietário</label>
              <b-form-select
                class="borderInput shadow-none"
                value-field="value"
                text-field="text"
                :options="tipoDocumento"
                v-model="selectContractant"
              >
              </b-form-select>
            </div>
            <div class="input-group" v-if="selectContractant === 2">
              <input
                v-model="contratanteUN.cnpj"
                v-mask="maskCpfCnpjContractant"
                maxlength="18"
                @input="checkInputLengthContract"
                class="input borderInput"
              />
              <label class="user-label"> CNPJ </label>
            </div>
            <div class="input-group" v-if="selectContractant === 1">
              <input
                v-mask="maskCpfCnpjContractant"
                maxlength="18"
                @input="checkInputLengthContract"
                v-model="contratanteUN.cpf"
                class="input borderInput"
              />
              <label class="user-label"> CPF </label>
            </div>
            <button class="addRoute" @click="insertContractant">
              Adicionar
            </button>
          </div>
          <div class="contentRoute">
            <div class="contentPercurso">
              <ul class="uf-list">
                <li
                  v-for="(item, index) in dadosMdfe.rodoviario.contratante"
                  :key="index"
                >
                  CPF/CNPJ: {{ item.cpf || item.cnpj }}
                  <b-icon-x-circle
                    @click="removeContractant(index)"
                    class="iconPercurso"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="rowContentFooter">
      <div class="btnsContainerFooterInit">
        <b-button class="btnsSaveNeutral" @click="clear"
          >Novo Manifesto Eletrônico</b-button
        >
        <b-button
          @click="sendMdfe"
          :disabled="loadingToSend"
          v-if="
            dadosMdfe.id &&
            (dadosMdfe.response === '' || dadosMdfe.response === null) && (dadosMdfe.status === '' || dadosMdfe.status === null)
          "
          class="btnsSave"
          >Emitir
          <b-spinner
            v-if="loadingToSend"
            small
            label="Small Spinner"
            class="loadingToSend"
          ></b-spinner
        ></b-button>

        <b-button
          @click="updateOrSaveMdfe"
          v-if="dadosMdfe.response === '' || dadosMdfe.response === null"
          class="btnsSave"
          >{{ dadosMdfe.id ? "Atualizar" : "Salvar" }}</b-button
        >
      </div>
    </div>
    <ModalConductor @getNewConductor="getAllConductor" />
    <ModalVehicle @getNewVehicle="getAllVehicle" />
    <ModalCreateProducts
      @getAllNewProduct="handleCreatedNewProduct"
      :idProductFromSearch="idProductFromSearch"
    />
  </div>
</template>
<script>
import mixinMdfe from "../../mixins/Mdfe/Mdfe";

export default {
  mixins: [mixinMdfe],
};
</script>

<style scoped>
.containerGeralMdfe {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 12px;
  margin-bottom: 100px;
}
.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}
.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  max-width: 100%;
  border: 1px solid rgb(200, 200, 200);
  border-radius: 5px;
}
.headTable {
  color: #fff;
  background: #00395d;
  text-align: center;
  height: 30px;
  border-bottom: 1px solid rgb(200, 200, 200);
}
tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-size: 12px;
  font-weight: normal;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}
.contentOtherInfos {
  min-height: 35vh;
  margin-bottom: 70px;
  background: #f5f5f5;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 0 0 10px 10px;
}
.btnAdd {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  height: 20px;
  background: #00395d;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 0 15px;
  margin-left: 10px;
  white-space: nowrap;
}

.btnAdd:hover {
  border: 1px solid #00395d;
  color: #00395d;
  background: whitesmoke;
}

.lista-adicionados {
  width: 30%;
  background: whitesmoke;
  border-radius: 8px;
  padding: 10px;
  margin-top: 10px;
}
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
  color: #333;
  transition: color 0.3s;
  margin: 0;
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox .checkmark {
  width: 14px;
  height: 14px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
  transform-style: preserve-3d;
}

.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 12px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #000000;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #f0f0f0;
}

.custom-checkbox:hover {
  color: #666;
}

.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}

.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s,
    transform 0.3s;
}
.carroselCtn {
  display: flex;
  gap: 10px;
  background: #fdfdfd;
  border-bottom: 1px dashed #00395d;
  padding: 0px 10px 0 10px;
  border-radius: 5px 5px 0 0;
}

.StatementOnAccount {
  display: flex;
  align-items: flex-end;
  padding-top: 10px;
  width: 100%;
  gap: 10px;
  transition: transform 0.5s ease-in-out;
}
.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 30px;
  background: #e4e4e4;
  color: #000000;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  height: 31px;
  background-color: #00395d;
  color: white;
  border-bottom: 4px solid rgb(212, 212, 212);
  padding-bottom: 1px;
  transform: translateY(-4px);
}

.StatementOnAccountItem:hover {
  background-color: #00395d;
  color: white;
}

.StatementOnAccountItem:focus {
  background: #000;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.loadingToSend {
  position: absolute;
  right: 10px;
}

.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.custom-select-sm {
  height: 28px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 12px;
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 4px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  z-index: 10;
}

.user-label-disabled {
  position: absolute;
  left: 10px;
  font-size: 9px;
  bottom: 22px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background-color: #ffffff;
}

.user-label-disabledKey {
  position: absolute;
  left: -4px;
  font-size: 12px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  background-color: #ffffff;
}

.input {
  font-size: 11px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 9px;
  bottom: 24px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px !important;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px !important;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  box-shadow: none !important;
  border: 1px solid #505050;
}

.title {
  font-size: 15px;
  color: rgb(95, 95, 95);
  margin-bottom: 10px;
  border-bottom: 1px solid rgb(230, 230, 230);
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: rgb(226, 226, 226);
  border-radius: 5px;
  border: none;
  background: #00395d;
  align-items: center;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
}

.content-form-btn {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.form-btn {
  width: 40%;
  height: 24px;
  margin-top: 35px;
}

.form-btn:hover {
  border: 1px solid #00395d;
  color: #00395d;
  background: whitesmoke;
}

.form-btn {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background: #fbfbfb;
  border: 1px solid #00395d;
  border-radius: 3px;
  width: 10%;
  box-shadow: 0px 1px 1px 0px black;
}

.addRoute:hover {
  border: 1px solid #00395d;
  color: #00395d;
  background: whitesmoke;
}

.addRoute {
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  height: 20px;
  background: #00395d;
  color: white;
  border: 1px solid #e1e1e1;
  border-radius: 3px;
}

.addKey:hover {
  border: 1px solid #00395d;
  background: whitesmoke;
}

.addKey {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: white;
  border-radius: 5px;
  border: none;
  background: #00395d;

  align-items: center;
}

.contentRoute {
  position: absolute;
  right: 10px;
  height: 70px;
  width: 29%;
  background: whitesmoke;
  border-radius: 8px;
  padding: 10px;
}

.contentReboq {
  background: whitesmoke;
  border-radius: 8px;
  padding: 10px;
}

.contentKey {
  width: 60%;
  background: whitesmoke;
  border-radius: 8px;
  padding: 10px;
}

.uf-list {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: 10px;
}

.descriptionObs {
  margin: 0px;
  color: #666360;
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
  font-size: 11px;
}
.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 30px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
}
.uf-list li {
  padding: 5px 15px 5px 15px;
  border-radius: 5px;
  position: relative;
  background-color: #cbcbcb;
}

.iconPercurso {
  position: absolute;
  color: #c93b3b;
  top: -5px;
  background: whitesmoke;
  right: -3px;
  border-radius: 50%;
}

.tdPercurso {
  color: #c93b3b;
  background: whitesmoke;
  border-radius: 50%;
}

.rowContentFooter {
  display: flex;
  width: 80vw;
  padding: 15px 10px 30px 10px;
  justify-content: space-between;
  gap: 10px;
  height: 60px;
  bottom: 0;
  background: #f9f9f9;
  position: fixed;
  z-index: 8000;
}

.btnsContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.btnsContainerFooterInit {
  display: flex;
  width: 100%;
  gap: 20px;
  justify-content: space-between;
  align-items: center;
}

.btnsSave {
  border-radius: 5px;
  background-color: #00395d;
  width: 24%;
  border: none;
  color: white;
  font-size: 12px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #ececec;
  width: 24%;
  border: 1px solid rgb(222, 221, 221);
  color: rgb(0, 0, 0);
  font-size: 12px;
}

.input-group {
  width: 30%;
}

.input-group-key {
  width: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .rowContent {
    flex-direction: column;
  }
  .selectPlus {
    width: 100%;
  }
  .input-group {
    width: 100% !important;
  }
  .rowContentFooter {
    display: flex;
    width: 100vw !important;
    padding: 5px;
    gap: 5px;
    height: 60px;
    bottom: 0;
  }
  .btnsSave {
    width: 100px;
    font-size: 11px;
  }
  .btnsSaveNeutral {
    width: 100px;
    font-size: 11px;
  }
}
</style>